import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { useSession } from "../state";
import { AuthShell } from "./Login";

export function Forgot() {
  const { forgotPassword, confirmForgotPassword, signIn } = useSession();
  const nav = useNavigate();

  const [stage, setStage] = useState<"email" | "reset">("email");
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const sendCode = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true); setErr(null);
    try {
      await forgotPassword(email.trim());
      setStage("reset");
    } catch (e: any) {
      setErr(e?.message || "couldn't start reset");
    } finally { setBusy(false); }
  };

  const reset = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true); setErr(null);
    try {
      await confirmForgotPassword(email.trim(), code.trim(), password);
      await signIn(email.trim(), password);
      nav("/", { replace: true });
    } catch (e: any) {
      setErr(e?.message || "couldn't reset");
    } finally { setBusy(false); }
  };

  return (
    <AuthShell>
      <h1 className="font-display font-black text-3xl mb-1">reset password</h1>
      {stage === "email" ? (
        <>
          <p className="text-ink-soft mb-6 text-sm">we&rsquo;ll send you a 6-digit code.</p>
          <form onSubmit={sendCode} className="space-y-3">
            <input type="email" required autoComplete="email" className="input" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="email" />
            <button type="submit" disabled={busy} className="btn-primary w-full">
              {busy ? "sending…" : "send code"}
            </button>
            {err && <p className="text-sm text-coral-dark">{err}</p>}
          </form>
        </>
      ) : (
        <>
          <p className="text-ink-soft mb-6 text-sm">enter the code we sent and pick a new password.</p>
          <form onSubmit={reset} className="space-y-3">
            <input inputMode="numeric" autoComplete="one-time-code" maxLength={6} className="input text-center tracking-[0.4em] text-lg" value={code} onChange={(e) => setCode(e.target.value)} placeholder="123456" required />
            <input type="password" autoComplete="new-password" minLength={10} className="input" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="new password" required />
            <button type="submit" disabled={busy} className="btn-primary w-full">
              {busy ? "resetting…" : "reset and sign in"}
            </button>
            {err && <p className="text-sm text-coral-dark">{err}</p>}
          </form>
        </>
      )}
      <p className="mt-6 text-sm text-ink-soft text-center">
        remembered? <Link to="/login" className="underline hover:text-ink">sign in</Link>
      </p>
    </AuthShell>
  );
}
